<template>
	<div class="home">
		<div class="home__carousel">
			<el-carousel height="460px">
				<el-carousel-item
					v-for="(item, index) in carouselList"
					:key="index"
				>
					<a :href="item.url" :title="item.imgName">
						<img
							:src="item.imgSrc"
							:alt="item.imgName"
							width="100%"
							height="auto"
						/>
					</a>
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="home_content">
			<div class="home_content_first">
				<p calss="home_content_three_p">
					<span style="color: #00a1e0">园区</span>动态
				</p>
				<span class="home_content_three_span">PARK DYNAMICS</span>
				<router-link to="/ParkDynamics/news"
					><span class="home_content_first_more"
						>MORE +</span
					></router-link
				>
				<div class="home_content_first_text">
					<div
						class="home_content_first_text_div"
						v-for="item in parksDynamicList"
						:key="item.id"
					>
						<img :src="item.img" :alt="item.title"  style="width:360px;height:210px;display: block"/>
						<p class="home_content_first_text_div_firstP">
							{{ item.title }}
						</p>
						<p class="home_content_first_text_div_twoP">
							{{ item.content| removeHtml}}
						</p>
						<div class="home_content_first_text_div_content">
							<span>{{ item.publishtime | formatDate }}</span>
							<router-link
								:to="
									parkDynamicsMap[item.infotype - 1] +
									`/${item.id}`
								"
								tag="a"
								>查看详情>></router-link
							>
						</div>
					</div>
				</div>
			</div>
			<div class="home_content_two">
				<p calss="home_content_three_p">
					<span style="color: #00a1e0">智慧</span>党建
				</p>
				<span class="home_content_three_span">PARTY BUILDING</span>
				<router-link to="/PartyBuilding/activities"
					><span class="home_content_first_more"
						>MORE +</span
					></router-link
				>
				<div class="home_content_two_text">
					<div class="home_content_two_text_left">
						<img src="@/assets/images/img.png" alt="" />
					</div>
					<div class="home_content_two_text_right">
						<ul class="home_content_two_text_right_list">
							<router-link
								:to="
									partyBuildingMap[item.parktype - 1] +
									`/${item.id}`
								"
								tag="li"
								v-for="item in partyBuildingList"
								:key="item.id"
							>
								<div>
									<p><span>.</span>{{ item.title }}</p>
									<span>{{ item.ctime | formatDate }}</span>
								</div>
							</router-link>
						</ul>
					</div>
				</div>
			</div>
			<div class="home_content_three">
				<p calss="home_content_three_p">
					<span style="color: #00a1e0">智慧</span>园区
				</p>
				<span class="home_content_three_span">SMART PARK</span>
				<div class="home_content_three_firstDiv">
					<p>{{ company }}定制化开发的智慧园区云平台</p>
					<p>
						从线上解决在园企业不同的服务需求，提升{{ company }}的综合服务能力
					</p>
					<p>和效力打造高效的综合管理、业务处理和高效服务平台</p>
				</div>
				<div class="home_content_three_twoDiv">
					<div>
						<img
							src="@/assets/images/icon-BusinessSupportPlatform.png"
							alt=""
						/>
						<p>业务支撑平台</p>
					</div>
					<div>
						<img
							src="@/assets/images/icon-OperationManagementPortal.png"
							alt=""
						/>
						<p>运营管理门户</p>
					</div>
					<div>
						<img
							src="@/assets/images/icon-estateManagement.png"
							alt=""
						/>
						<p>物业管理平台</p>
					</div>
					<div>
						<img
							src="@/assets/images/icon-InvestmentManagement.png"
							alt=""
						/>
						<p>招商管理平台</p>
					</div>
					<div>
						<img
							src="@/assets/images/icon-BusinessServiceCenter.png"
							alt=""
						/>
						<p>物业服务中心</p>
					</div>
					<div>
						<img
							src="@/assets/images/icon-PolicyServices.png"
							alt=""
						/>
						<p>政策服务</p>
					</div>
					<div>
						<img src="@/assets/images/icon-bigData.png" alt="" />
						<p>大数据分析</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
	name: 'Home',
	components: {},
	data() {
		return {
			partyBuildingMap: [
				'/PartyBuilding/activities',
				'/PartyBuilding/learningGarden',
				'/PartyBuilding/powerfulCountries',
			],
			parkDynamicsMap: [
				'/ParkDynamics/news',
				'/ParkDynamics/notice',
				'/ParkDynamics/technologyPolicy',
			],
		}
	},
	created() {
		this.fetchPartyBuilding()
		this.fetchCarousel()
		this.fetchParksDynamic()
	},
	filters: {
		removeHtml: (str) => {
			return str.replace(/<[^>]+>/g, '').replace(/[ ]|[&nbsp;]/g, '')
		},
	},
	computed: {
	  ...mapState(['company']),
    ...mapState('HOME', [
      'partyBuildingList',
      'carouselList',
      'parksDynamicList',
    ]),
	},
	methods: {
		...mapActions('HOME', [
			'fetchPartyBuilding',
			'fetchCarousel',
			'fetchParksDynamic',
		]),
	},
}
</script>

<style lang="scss" scoped>
p {
	margin: 0px;
	padding: 0px;
}

.home {
	&_content {
		width: 1200px;
		margin: 0 auto;
		// border: 1px solid red;

		&_first {
			height: 460px;
			background: #ffffff;
			margin: 30px 0px;
			padding: 20px 30px;
			position: relative;

			&_more {
				position: absolute;
				top: 20px;
				right: 30px;
				padding: 3px 8px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(0, 0, 0, 0.25);

				background: #ffffff;
				border-radius: 2px;
				border: 1px solid rgba(0, 0, 0, 0.15);
			}

			&_text {
				margin-top: 10px;
				display: flex;
				border-top: 1px solid #f0f0f0;
				padding-top: 30px;

				&_div {
					width: 360px;
					margin-right: 30px;

					&_firstP {
						font-size: 16px;
						font-weight: 400;
						color: #000000;
						@include ellipsis();
					}

					&_twoP {
						font-size: 14px;
						font-weight: 400;
						color: rgba(0, 0, 0, 0.45);
						margin: 10px 0px 10px;
						@include ellipsis-line(3);
					}

					&_content {
						position: relative;

						span {
							position: absolute;
							left: 0px;
							font-size: 14px;
							font-family: PingFangSC-Regular, PingFang SC;
							font-weight: 400;
							color: rgba(0, 0, 0, 0.45);
						}

						a {
							position: absolute;
							right: 0px;
							font-size: 14px;
							font-family: PingFangSC-Regular, PingFang SC;
							font-weight: 400;
							color: rgba(0, 0, 0, 0.45);
						}
					}
				}

				&_div:last-child {
					margin-right: 0px;
				}
			}
		}

		&_two {
			position: relative;
			height: 437px;
			background: #ffffff;
			padding: 20px 30px;

			&_text {
				padding: 20px;
				border-top: 1px solid #f0f0f0;
				margin-top: 10px;
				display: flex;

				&_left {
					width: 540px;
					height: 304px;
				}

				&_right {
					margin-left: 40px;
					flex: 1;

					&_list li {
						margin-bottom: 20px;
						cursor: pointer;

						div {
							display: flex;

							p {
								margin-right: 20px;
								flex: 1;
								width: 0;
								font-size: 16px;
								color: #000000;
								@include ellipsis();
							}

							span {
								font-size: 16px;
								color: rgba(0, 0, 0, 0.25);
							}
						}
					}
				}
			}
		}

		&_three {
			height: 393px;
			background: #ffffff;
			margin: 30px 0px 60px;
			padding: 21px 30px 0px;
			text-align: center;

			&_p {
				width: 96px;
				height: 33px;
				font-size: 24px;
				font-family: PingFangSC-Semibold, PingFang SC;
				font-weight: 600;
				color: #00a1e0;
				line-height: 33px;
			}

			&_span {
				width: 78px;
				height: 17px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #d3d3d3;
				line-height: 17px;
			}

			&_firstDiv {
				// margin-top:10px;
				border-top: 1px solid #f0f0f0;
				margin: 10px auto 0px;
				padding-top: 20px;
				width: 613px;
				height: 84px;
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(0, 0, 0, 0.45);
				line-height: 28px;
			}

			&_twoDiv {
				display: flex;
				padding: 40px;

				div {
					width: 100px;
					margin-right: 60px;

					p {
						margin-top: 20px;
						height: 22px;
						font-size: 16px;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: rgba(0, 0, 0, 0.85);
						line-height: 22px;
					}
				}

				div:last-child {
					margin-right: 0px;
				}
			}
		}
	}
}
</style>
